exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".batch-update-checkType[data-v-1c1c295a]{position:relative}", ""]);

// exports
